import { render, staticRenderFns } from "./form-user.vue?vue&type=template&id=3d0acbe4&scoped=true"
import script from "./form-user.vue?vue&type=script&lang=js"
export * from "./form-user.vue?vue&type=script&lang=js"
import style0 from "./form-user.vue?vue&type=style&index=0&id=3d0acbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0acbe4",
  null
  
)

export default component.exports